// extracted by mini-css-extract-plugin
module.exports = {"history":"ActivityReviewHistory_history__39j6I","loading-wrapper":"ActivityReviewHistory_loading-wrapper__3KsPy"};